import { generatePath } from 'react-router-dom'

import Routes from '@tabeeb/routes'

import OpenInNewTabIconButton from '../OpenInNewTabIconButton'

export interface ContentTrainingMaterialLinkButtonProps {
  id: number
  disabled?: boolean
}

const ContentTrainingMaterialLinkButton: React.FC<ContentTrainingMaterialLinkButtonProps> = ({
  id,
  disabled = false,
}) => {
  return <OpenInNewTabIconButton disabled={disabled} url={generatePath(Routes.contentTrainingMaterialView, { id })} />
}

export default ContentTrainingMaterialLinkButton
